import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../module/legacy/forms/mui-input.directive';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { ViewPasswordComponent } from '../../../ui/form/view-password.component';
import { AbstractEditFormComponent } from '../form/abstract-edit-form.component';
import { AccountEditFormLayoutComponent } from '../form/layout/account-edit-form-layout.component';
@Component({
    selector: 'account-edit-password',
    templateUrl: './account-edit-password.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./account-edit-password.scss'],
    standalone: true,
    imports: [
        TranslationModule,
        FormsModule,
        MuiInputDirective,
        ViewPasswordComponent,
        AccountEditFormLayoutComponent,
        InputWrapComponent,
        InputWrapBodyDirective,
        CommonModule
    ]
})
export class AccountEditPasswordComponent extends AbstractEditFormComponent {}
